##all questions struct
@aq = {}

answerIs = (qLabel, aLabel)->
    a = aq[qLabel].answer
    a and a.label is aLabel

addQ = (qLabel, options)-> aq[qLabel] = new Question qLabel, options

q = addQ imageryTakenUnderage, [
    new Option underAgeImagery, whoIsFeatured, 'Yes'
    new Option overAgeImagery,  whoIsFeatured, 'No'
]
q.title = "Was the person under 18 when the image or video was taken?"
q.shown = true

q = addQ whoIsFeatured, [
    new Option myself, ageNow,       "It's about an intimate image or video of me"
    new Option other,  relationship, "It's about the person in the intimate image or video"
]
q.title = "Is this about an intimate image or video of you?"

q = addQ relationship, [
    new Option guardianUnderage,  ageNow, 'They are under 18 and I am their parent or guardian'
    new Option guardianIncapable, ageNow, 'They are incapable of managing their affairs and I am their parent or guardian'
    new Option unrelated,         ageNow, "They have authorised me to make this complaint"
]
q.title = "I declare that I am entitled to make this complaint on their behalf as:"

q = addQ ageNow, [
    new Option u18,    gender, "Under 18", 'isOverageImagery'
    new Option f18t24, gender, "18-24"
    new Option f25t34, gender, "25-34"
    new Option f35t44, gender, "35-44"
    new Option o44,    gender, "45+"
]
q.title = "Which age category best describes the victim now?"
q.small = "When a person <b>under 18</b> submits an intimate image abuse report <b>please be advised</b> that, in certain circumstances i.e. where child protection and welfare concerns arise, it may be necessary or advisable for Hotline.ie to disclose all details to An Garda Síochána, regardless of the outcome sought by the U18 reporter i.e. \"content removal only\". If a victim is under 18 different laws (Acts) may apply, such as the <i>Child Trafficking and Pornography Act 1998 as amended by the Criminal Law (Sexual Offences) Act 2017</i>."

q = addQ gender, [
    new Option female,         didYouConsentToTake, "Female"
    new Option male,           didYouConsentToTake, "Male"
    new Option transgender,    didYouConsentToTake, "Transgender"
    new Option diverse,        didYouConsentToTake, "Gender Diverse"
    new Option intersex,       didYouConsentToTake, "Intersex"
    new Option preferNotToSay, didYouConsentToTake, "Prefer not to say"
]
q.title = "Does the victim identify as:"

q = addQ didYouConsentToTake, [
    new Option consentedToTake,     didYouConsentToShare, 'Yes'
    new Option notConsentedToTake,  didYouConsentToShare, 'No'
]
q.title = "Did the victim consent to the intimate image or video being taken?"
q.small = "This question seeks to establish the nature of potential offences. We’re only seeking necessary information that will aid in the removal of the imagery or that will assist the Gardaí if you choose to have the matter investigated."

q = addQ didYouConsentToShare, [
    new Option consentedToShare,     victimLocation, 'Yes'
    new Option notConsentedToShare,  victimLocation, 'No'
]
q.title = "Did the victim consent to the intimate image or video being posted/shared?"

q = addQ victimLocation, [
    new Option victimInIreland,      willingToTakeAction, "The victim lives in Ireland"
    new Option perpetratorInIreland, willingToTakeAction, "The person responsible lives in Ireland"
    new Option bothInIreland,        willingToTakeAction, "Both the victim and person responsible live in Ireland"
    new Option noneInIreland,        null,               "Neither the victim nor the person responsible live in Ireland"
]
q.title = "Which of the following applies:"
q.stub  = """
Hotline.ie is only able to help where:

<ul>
<li>the victim ordinarily resides in Ireland, or</li>
<li>the person who posted or threatened to post the intimate image or video ordinarily resides in Ireland</li>
</ul>

<b>If you ordinarily reside outside Ireland</b>, but require support in respect of intimate image/video abuse we would recommend that you report what is happening to the police.
<br>
<br>
Please visit this <a href='/what-to-report/iia/international-resources'>resources page</a> where you may be able to find an organisation in your country to provide you with further support.
<br>
<br>
<b>If you are being blackmailed over your intimate images?</b>

<ul>
<li>Don't pay, nor give them any images - giving into a blackmailer will only result in more demands.</li>
<li>Stop all contact with the blackmailer.</li>
<li>Take screenshots of the threats and then block the user.</li>
<li>Report the accounts being used to blackmail you to the platforms.</li>
<li>Report it to the police.</li>
</ul>


If you still need to contact us, you can do so by submitting a <a href='/contact-us/report'>Query</a>
"""

q = addQ willingToTakeAction, [
    new Option legalAction,    hasIncidentBeenReported, "I want the intimate image or video removed, and I want the matter to be investigated by the Gardaí so that action may be taken against the person responsible"
    new Option contentRemoved, done, "I want the intimate image or video removed only", "isUnderage"
]
q.title = "What outcome are you seeking?"

screenshotsNeeded =->
    isUa = answerIs ageNow, u18
    if isUa then doYouKnowPerpetrator else hasScreenshots
q = addQ hasIncidentBeenReported, [
    new Option beenReported, screenshotsNeeded, 'Yes'
    new Option notReported,  screenshotsNeeded, 'No'
]
q.title = "Are An Garda Síochána currently involved in this case?"
q.small = "<b>Please note</b>: If the Gardaí are involved we may need to defer taking action to avoid prejudicing a criminal investigation."

q = addQ hasScreenshots, [
    new Option hasScreenshots, doYouKnowPerpetrator, 'Yes'
    new Option noScreenshots,  doYouKnowPerpetrator, 'No'
]
q.title = "Do you have any screenshots or other information that will help us understand what's been happening?"
q.small = """
Do not send screenshots to Hotline.ie (by any means). Please note that Hotline.ie does not require any screenshots as 'proof', however it might be good to keep a copy or screenshot of the image or video and any other content for your own records in case your decide to access legal support, or should it be required in your interactions with An Garda Síochána.
<br>
<br>
This guidance is for collecting evidence of intimate image abuse concerning adults. <b>Be mindful that possessing, creating or sharing sexualised images of people <u>under 18 may constitute a crime</u></b>.<span class="small icon" title="More details on Irish legislation" onclick="app.cpPopupShown = true"></span>
"""

q = addQ doYouKnowPerpetrator, [
    new Option perpetratorKnown,   haveWeGardaConsent, 'Yes'
    new Option perpetratorUnknown, haveWeGardaConsent, 'No'
]
q.title = "Do you personally know who is responsible for posting the intimate image or video?"

q = addQ haveWeGardaConsent, [
    new Option gardaConsentGiven,   done, 'Yes'
    new Option noGardaConsentGiven, null, 'No'
]
q.title = "Do you consent for your contact details to be provided to An Garda Síochána?"
q.small = "<b>Please note</b>: If you do not consent to us passing your contact details to An Garda Síochána, particularly as you are seeking action against the person responsible, it will <b>not</b> be possible for Hotline.ie to effectively manage your complaint."
q.stub  = """
In order to proceed with the report submission you need to agree to your contact details being shared by Hotline.ie with An Garda Síochána for the purpose of follow-up action in respect of your sought outcome in relation to this report.
<br>
<br>
Alternatively you may wish to consider other reporting options available through the Hotline.ie service or other support services available in Ireland, click <a href='/what-to-report/iia/resources'>here</a> to view the list or click here to consult the intimate image abuse <a href='/what-to-report/iia/faq'>FAQs</a>.
"""
